var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1086 31.5944L28.956 18.7548C29.2822 18.4284 29.4828 17.9843 29.4828 17.5214V7.64089C29.4828 6.68307 28.6994 5.89648 27.7395 5.89648H17.8492C17.3867 5.89648 16.9428 6.08912 16.6166 6.41553L3.78523 19.2578C3.10609 19.9373 3.10609 21.045 3.78523 21.7246L13.6407 31.589C14.3252 32.2739 15.4268 32.2739 16.1086 31.5944ZM23.4989 9.40403C24.178 8.72446 25.2823 8.72446 25.9641 9.40403C26.6459 10.0836 26.6432 11.1886 25.9641 11.8708C25.285 12.5531 24.1807 12.5504 23.4989 11.8708C22.8171 11.1912 22.8198 10.0836 23.4989 9.40403Z",
    fill: "#F1A98C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscount);
export default __webpack_public_path__ + "static/media/icon_discount.c98e119e1e1d1cf3e5e865d48b03feaa.svg";
export { ForwardRef as ReactComponent };